<template>
<v-card class="height=100%">

  <!-- <tour v-model='tour' :touch='showTour' /> -->

  <!-- <v-card-actions>
    <v-btn @click='showTour++' >Next</v-btn>
  </v-card-actions> -->

  <v-card-title class='subtitle-1 overline grey lighten-4 py-1' >
    <v-icon class='mx-2' color='info' >tour</v-icon>
    Get started with AppointmentGuru
    <v-spacer />
    <v-btn v-if='!showScan' @click='showScan=true' small icon ><v-icon small >qr_code</v-icon></v-btn>
  </v-card-title>
  <v-card-text class='hidden-sm-and-up justify-center' >
    <center>
      Looks like you're on a mobile device.
      <v-btn @click='$emit("install")' flat >Install AppointmentGuru on your device</v-btn>
    </center>
  </v-card-text>

  <center>
  <v-card v-if='showScan' width='300' class='grey lighten-4 pb-3 hidden-xs-only my-4' >
    <!-- <v-card-title >
      Scan here to follow along on your mobile device
    </v-card-title> -->
    <v-card-text class='hidden-xs-only justify-center' >
      <center>
        <v-img width='100' height='100'
          src='https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://app.appointmentguru.co/#/get-started' />

        <v-btn absolute fab small top right @click='showScan=false' ><v-icon>close</v-icon></v-btn>
      </center>
      <p class='caption mt-2' ><b>Tip:</b> Scan this code to open the app on your mobile device.
      Then you can view the instructions and videos on your computer while you complete the tasks on your phone (or vice versa)
      </p>
    </v-card-text>
  </v-card>
  </center>

  <!-- <v-btn @click='showMenu=true' ></v-btn> -->
  <v-menu top left nudge-left
    v-model='showMenu'
    activator="#main-speed-dail" :offset-x="true" >
    <v-list dense
      transition="slide-x-transition"
      class='pa-0 elevation-10 mr-3 mb-2 blue white--text overline' >
      <v-list-tile >
        <v-list-tile-content >
          <v-list-tile-title>Start here</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action >
          <v-icon dark >arrow_forward</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-menu>

  <v-menu bottom nudge-bottom
    v-model='showFindGuides'
    activator="#global-guides-btn"
    :offset-y="true" >
    <v-card class='mt-3 mr-1'>
      <v-card-title class='subtitle-1 overline' >
        <v-icon class='mr-1' color='info' >tour</v-icon>
        Guides are here
      </v-card-title>
      <v-card-text>
        You can always return to this guide using the
        <v-icon class='mr-1' color='info' >tour</v-icon>
        icon in the toolbar above
      </v-card-text>
      <v-card-actions >
        <v-spacer/>
        <v-btn flat @click='showFindGuides=false' >Got it</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>

  </v-card-text>

  <v-card-text class='subheading justify-center' >
    <blockquote class="blockquote pl-0" >
    This guide will walk you through the basics of using AppointmentGuru.
    You will learn how to: create an appointment, add medical aid codes to the appointment, create an invoice and share the invoice with your clients
    </blockquote>
  </v-card-text>
  <v-divider/>
  <v-card-text class="pa-0">
    <v-timeline align-top dense >
        <template v-for='(item, index) in items'  >
          <v-timeline-item
            color="success" icon='plus'
            class="pb-0"
            :class="{'accent lighten-2': step===index}"
            :key='item.id'
            @click='setStep(item)' >
            <template v-slot:icon>
              <v-avatar class='white--text' size=10 >
                <v-icon color='white' v-if='item.done === true' >check</v-icon>
                <span v-else >{{ index + 1 }}</span>
              </v-avatar>
            </template>
            <v-layout class="pt-2" >
              <v-flex>
                <strong class='mt-1' >{{ item.title }}</strong>
                <div class="text-caption" v-text="item.description" />
              </v-flex>
              <v-flex class='justify-right'>
                <v-btn
                  :disabled='item.disabled === true'
                  :flat='item.done'
                  @click='setStep(item)'
                  color='success' class='right' >Go</v-btn>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </template>
    </v-timeline>
  </v-card-text>
  <v-divider/>
  <v-card-actions class='pl-0' >
    <v-btn to='/' flat class='pl-0' >Done</v-btn>
    <v-spacer/>
    <!-- <v-btn flat >Next: cloning, invoicing mulitple appointments, tracking payments</v-btn> -->
  </v-card-actions>
  <v-divider/>
  <v-footer class='grey lighten-4 pl-3 caption' >
    AppointmentGuru > Guides > Getting started
  </v-footer>

  <v-dialog v-model="showInstructions" :fullscreen='$vuetify.breakpoint.xs' >
    <v-card v-if='selectedItem'>
      <v-card-title class='grey lighten-4 py-0' >
        {{selectedItem.title}}
        <v-spacer/>
        <v-btn small icon @click='showInstructions=false' >
          <v-icon small >close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text >
        <blockquote class='blockquote pa-0' v-text='selectedItem.description' />
      </v-card-text>
      <v-card-text>
        <v-layout row wrap >
          <v-flex xs12 sm12 md6 class='pa-2' v-if='selectedItem.instructions && selectedItem.instructions.video' >
            <div
              style="position: relative; padding-bottom: 62.5%; height: 0;">
              <iframe :src="selectedItem.instructions.video"
                frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen lazy
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
              </iframe>
            </div>
          </v-flex>
          <v-flex xs12 sm12 md6 class='px-2'
            v-if='selectedItem.instructions && selectedItem.instructions.steps' >
            <v-card flat height='100%'>
              <v-card-title class='title' >
                Instructions
              </v-card-title>
              <v-card-text class='subheading' >
                <ol>
                  <li v-for='item in selectedItem.instructions.steps' :key='item.title' >
                    <span v-text="item.title" />
                    <ol v-if='item.items' >
                      <li v-for='sub in item.items' :key='sub' v-text="sub" />
                    </ol>
                  </li>
                </ol>
              </v-card-text>
              <v-list subheader three-line class='elevation-5 mb-3 pa-0'
                v-if='(selectedItem.id === "add_codes" || selectedItem.id === "create_invoice") && lastAppointment' >
                <v-subheader class='grey lighten-4 overline my-0 py-0' >Appointment</v-subheader>
                <v-divider/>
                <appointment-list-item
                  :with-action='false'
                  :appointment='lastAppointment' >
                  <v-list-tile-action slot='actions' >
                    <appointment-action-menu :appointment='lastAppointment' >
                    </appointment-action-menu >
                  </v-list-tile-action>
                </appointment-list-item>
              </v-list>

              <v-card v-if='selectedItem.id === "send_invoice"' >
                <v-btn @click='loadInvoices' v-if="invoices.length === 0" >Load invoices</v-btn>
                <v-list three-line v-if='lastInvoice' >
                  <invoice-list
                    :invoices='[lastInvoice]'
                    :actions='invoiceActions'
                    v-on='invoiceEvents' />
                </v-list>
              </v-card>

              <template v-if='selectedItem.instructions && selectedItem.instructions.results' >
                <v-card-title class='title' >
                  By the end of this tutorial you will know:
                </v-card-title>
                <v-card-text class='subheading' >
                  <ol>
                    <li v-for='result in selectedItem.instructions.results'
                      :key='result'
                      v-text="result" />
                  </ol>
                </v-card-text>
              </template>

              <v-card-actions >
                <v-spacer/>
                <v-btn @click='showInstructions=false' color='primary' >Got it!</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-card>
</template>
<script>
// import Tour from './Tour.vue'
import GetStartedMixin from './data/guides/getstarted.js'
import AppointmentListItem from '@/components/appointment/AppointmentListItem.vue'
import AppointmentActionMenu from '@/components/appointment/actions/ActionMenu'
import InvoiceList from '@/components/invoice/InvoiceList.vue'
import InvoiceMixin from '@/mixins/invoice.js'
import Vue from 'vue'

import {mapGetters} from 'vuex'

export default {
  name: 'GetStarted',
  mixins: [GetStartedMixin, InvoiceMixin],
  components: {
    AppointmentListItem,
    AppointmentActionMenu,
    InvoiceList
  },
  data () {
    return {
      step: 0,
      level: 'basic', // intermetiate / advanced
      showInstructions: false,
      showMenu: false,
      showScan: true,
      showTour: 0,
      showFindGuides: false,
      selectedItem: null
    }
  },
  mounted () {
    let vm = this
    window.setTimeout(() => { vm.showFindGuides = true }, 1000)
  },
  methods: {
    setStep (item) {
      this.selectedItem = item
      this.showInstructions = true
    }
  },
  watch: {
    showInstructions () {
      if (this.showInstructions === false) {
        if (this.selectedItem && this.selectedItem.id === 'create_appointment') {
          this.showMenu = true
        }
      }
      Vue.set(this.selectedItem, 'done', true)
      this.step++
    }
  },
  computed: {
    ...mapGetters(['appointments', 'invoices']),
    lastAppointment () {
      if (this.appointments && this.appointments.length > 0) {
        return this.appointments[this.appointments.length - 1]
      }
      return null
    },
    lastInvoice () {
      if (this.invoices && this.invoices.length > 0) {
        return this.invoices[this.invoices.length - 1]
      }
      return null
    },
    numAppointments () {
      if (this.appointments) { return this.appointments.length }
      return 0
    },
    numInvoices () {
      if (this.invoices) { return this.invoices.length }
      return 0
    },
    tour () {
      return [
        {
          selector: '#global-link-calendar',
          title: 'Calendar',
          description: 'Your calendar shows your appointments in a calendar view - it\'s the best place to view, create and manage your appointments',
          attrs: {
            nudgeBottom: 15,
            bottom: true,
            offsetY: true
          }
        },
        {
          selector: '#global-link-clients',
          title: 'Clients',
          description: '...',
          attrs: {
            nudgeBottom: 15,
            bottom: true,
            offsetY: true
          }
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// GetStarted.vue?2392a94a